import React from 'react';
import ReactDOM from 'react-dom';
import { useState } from 'react';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import AbsenceCalendar from './AbsenceCalendar';
import AclContextProvider from '../../Modules/Acl/Components/AclContextProvider';
import { Provider } from 'react-redux';
import { store } from '../../store/store';

loadDOMComponent({
	selector: 'react-absence-calendar',
	callback: ({ container }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider>
						<AbsenceCalendar />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
